import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import EventDetail from './routes/EventDetail';
import Admin from './routes/Admin';
import CansEvent from './routes/CansEvent';
import GuestMenu from './menu/GuestMenu';
import MenuAdmin from './menu/MenuAdmin';
import Experience from './experience/Experience';
import PrintPage from './menu/PrintPage';
import { LanguageProvider } from './contexts/LanguageContext';

// The experience and menu pages carry their own header (awning, language switch), so they
// render without the site navbar, footer and the giant background wordmark.
const MENU_ROUTES = ['/', '/menu', '/menu/baski', '/mutfak'];

const Shell = () => {
  const { pathname } = useLocation();
  if (MENU_ROUTES.includes(pathname)) {
    return (
      <Routes>
        <Route path="/" element={<Experience />} />
        <Route path="/menu" element={<GuestMenu />} />
        <Route path="/menu/baski" element={<PrintPage />} />
        <Route path="/mutfak" element={<MenuAdmin />} />
      </Routes>
    );
  }
  return (
    <div className="App min-h-screen flex flex-col bg-light-bg text-text-dark relative overflow-hidden">
      {/* Giant LUCIEN14 Text Background */}
      <div className="fixed inset-0 flex items-center justify-center pointer-events-none overflow-hidden z-0">
        <h1 className="text-[15vw] sm:text-[18vw] md:text-[20vw] font-bold text-gray-100 opacity-15 sm:opacity-20 select-none whitespace-nowrap transform -rotate-3 sm:-rotate-6 md:-rotate-12 max-w-none">
          LUCIEN14
        </h1>
      </div>

      <Navbar />
      <main className="flex-grow relative z-10">
        <Routes>
          {/*<Route path="/events/cans" element={<CansEvent />} />*/}
          {/*<Route path="/events/:slug" element={<EventDetail />} />*/}
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <LanguageProvider>
      <Router>
        <Shell />
      </Router>
    </LanguageProvider>
  );
}

export default App;
